<template>
  <div>
    <i-select
      :filterable="true"
      :clearable="true"
      :multiple="multiple"
      :value="value"
      @input="input"
    >
      <i-option
        v-for="(item, key) in numbers"
        :key="key"
        :label="item.number"
        :value="item.number"
      />
    </i-select>
  </div>
</template>
<script>
  import { NumberService } from '@phone-number/services/NumberService';

  export default {
    props: {
      value: {
        type: [Array, String]
      },
      multiple: {
        type: Boolean,
        default: true
      }
    },
    data: () => ({
      numbers: []
    }),
    created() {
      NumberService.getSelectByUserId(this.$user.id).then((data) => {
        this.numbers = data || [];
        if (!this.multiple && this.numbers.filter((i) => i.number === this.value)?.length === 0) {
          this.$emit('input', '');
        }
      });
    },
    methods: {
      input(val) {
        this.$emit('input', val);
      }
    }
  };
</script>
